import React from "react"
import Link from "components/Link"
import { hrefIsRelative } from "lib/functions"
import arrowRightIcon from "./images/arrow-right.svg"
import Button from "components/ui/Button"

function Banner({ id, text, link, onClick }) {
  if (text) {
    const Component = link ? (hrefIsRelative(link) ? Link : "a") : "span"
    return (
      <div className="relative w-full bg-lush px-4 py-2 text-center text-base">
        <Component
          className="group font-bold text-white hover:text-white"
          href={link}
        >
          {text}
          {link && (
            <img
              className="-mt-px ml-2 inline-block h-3 transition-transform group-hover:translate-x-1"
              src={arrowRightIcon}
              alt="Arrow right"
            />
          )}
        </Component>
        <div className="absolute right-0 top-1/2 -translate-y-1/2">
          <Button
            className="mx-3 px-1"
            onClick={onClick}
            trackClick={`Banner Bar Closed ${id || ""}`}
            color="white"
            link
          >
            ✕
          </Button>
        </div>
      </div>
    )
  }
  return null
}

export default Banner
